import {createSlice, PayloadAction} from '@reduxjs/toolkit';

interface IChatReducer {
    isChatOpened: boolean
}

const initialState: IChatReducer = {
    isChatOpened: false
}

const chatStateSlice = createSlice({
    name: 'chat',
    initialState,
    reducers: {
        setIsChatOpened(state, action: PayloadAction<boolean>) {
            state.isChatOpened = action.payload;
        },
    },
});

const chat = chatStateSlice.reducer;

export const {
    setIsChatOpened
} = chatStateSlice.actions;

export default chat